import React, { Component } from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Spinner, Card, FloatingLabel, Form } from "react-bootstrap";
import logo from "../assets/images/logo.png";
import Swal from "sweetalert2";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

class PasswordResetRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      identifier: "",
      recoveryMethod: "phone", // "phone" or "email"
      loading: false,
      disabled: false,
    };
  }

  validatePhoneNumber = () => {
    const { identifier } = this.state;

    // Remove spaces and dashes for validation
    const cleanedPhone = identifier.replace(/[\s-]/g, "");

    // Nigerian phone number patterns:
    // - 11 digits starting with 0 (e.g., 08012345678)
    // - 10 digits without leading 0 (e.g., 8012345678)
    // - 13 digits with country code (e.g., 2348012345678)
    // - 14 digits with + prefix (e.g., +2348012345678)
    const phoneRegex = /^(\+?234|0)?[789][01]\d{8}$/;

    if (!cleanedPhone) {
      Swal.fire({
        title: "Error",
        text: "Please enter your Nigerian phone number",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else if (!phoneRegex.test(cleanedPhone)) {
      Swal.fire({
        title: "Invalid Phone Number",
        text: "Please enter a valid Nigerian phone number. Example: 08012345678 or 2348012345678",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      this.sendPasswordResetRequest();
    }
  };

  validateEmail = () => {
    const { identifier } = this.state;
    const trimmedEmail = identifier.trim().toLowerCase();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!trimmedEmail) {
      Swal.fire({
        title: "Error",
        text: "Please enter your email address",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else if (!emailRegex.test(trimmedEmail)) {
      Swal.fire({
        title: "Invalid Email",
        text: "Please enter a valid email address",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      this.sendPasswordResetRequest();
    }
  };

  validateAndSubmit = () => {
    const { recoveryMethod } = this.state;
    if (recoveryMethod === "email") {
      this.validateEmail();
    } else {
      this.validatePhoneNumber();
    }
  };

  sendPasswordResetRequest = () => {
    const self = this;

    const { identifier, recoveryMethod } = self.state;
    self.setState({ loading: true, disabled: true });

    const params = new URLSearchParams();
    if (recoveryMethod === "email") {
      params.append("email", identifier.trim().toLowerCase());
    } else {
      params.append("phone", identifier);
    }
    const url = `${baseUrl}/v2/password/request-reset?${params.toString()}`;

    axios
      .post(url)
      .then((response) => {
        const data = response.data;
        Swal.fire({
          title: "Password Reset Sent",
          text: data.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          self.setState({ identifier: "" });
        });
      })
      .catch((error) => {
        const data = error.response?.data;
        const msg =
          data?.message ??
          "There was an error while processing your reset request.";

        Swal.fire({
          title: "Error",
          text: msg,
          icon: "error",
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        self.setState({ loading: false, disabled: false });
      });
  };

  render() {
    const { loading, disabled, recoveryMethod, identifier } = this.state;
    return (
      <div className="loginContainer">
        <div
          className="d-flex justify-content-center"
          style={{
            backgroundColor: "rgba(0,0,0,0.7)",
            width: "100%",
            position: "absolute",
            top: 0,
            bottom: 0,
          }}
        >
          <Card
            style={{ backgroundColor: "rgba(255,255,255,0.7)" }}
            className="d-flex justify-content-center cardContainer loginContainer-content"
          >
            <img
              src={logo}
              style={{
                width: "15%",
                position: "absolute",
                top: 25,
                alignSelf: "center",
              }}
            />

            <h5
              className="nicfostText"
              style={{
                position: "relative",
                fontWeight: "bold",
                top: 5,
                color: "#333",
                textAlign: "center",
              }}
            >
              NIGERIAN COUNCIL OF FOOD SCIENCE AND TECHNOLOGY
              <br />
              (NiCFoST)
            </h5>
            <div className="mb-3"></div>
            <h6
              className="nicfostText"
              style={{
                position: "relative",
                marginLeft: 13,
                textAlign: "center",
                top: 45,
              }}
            >
              {recoveryMethod === "phone"
                ? "Enter your registered Nigerian phone number"
                : "Enter your registered email address"}
            </h6>

            <div className="container" style={{ marginTop: 50 }}>
              <Form>
                <div className="mb-3 d-flex justify-content-center">
                  <div className="btn-group" role="group">
                    <button
                      type="button"
                      className={`btn ${recoveryMethod === "phone" ? "btn-success" : "btn-outline-success"}`}
                      onClick={() => this.setState({ recoveryMethod: "phone", identifier: "" })}
                      style={recoveryMethod === "phone" ? { backgroundColor: "#003314", borderColor: "#003314" } : { color: "#003314", borderColor: "#003314" }}
                    >
                      Phone
                    </button>
                    <button
                      type="button"
                      className={`btn ${recoveryMethod === "email" ? "btn-success" : "btn-outline-success"}`}
                      onClick={() => this.setState({ recoveryMethod: "email", identifier: "" })}
                      style={recoveryMethod === "email" ? { backgroundColor: "#003314", borderColor: "#003314" } : { color: "#003314", borderColor: "#003314" }}
                    >
                      Email
                    </button>
                  </div>
                </div>

                <Form.Floating className="mb-3">
                  {recoveryMethod === "phone" ? (
                    <>
                      <input
                        className="form-control shadow-none"
                        type="tel"
                        id="phone"
                        placeholder="e.g. 08012345678"
                        value={identifier}
                        onChange={(e) => this.setState({ identifier: e.target.value })}
                      />
                      <label htmlFor="phone">Nigerian Phone Number (e.g. 08012345678)</label>
                    </>
                  ) : (
                    <>
                      <input
                        className="form-control shadow-none"
                        type="email"
                        id="email"
                        placeholder="e.g. user@example.com"
                        value={identifier}
                        onChange={(e) => this.setState({ identifier: e.target.value })}
                      />
                      <label htmlFor="email">Email Address</label>
                    </>
                  )}
                </Form.Floating>

                <div className="d-grid gap-2 mb-3" style={{ marginTop: 30 }}>
                  <button
                    style={{ backgroundColor: "#003314" }}
                    type="button"
                    className="btn btn-success btn-lg"
                    onClick={() => this.validateAndSubmit()}
                    disabled={disabled}
                  >
                    {loading ? (
                      <Spinner animation="border" variant="light" size="sm" />
                    ) : (
                      "Send Password Reset Link"
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

export default PasswordResetRequest;
